import { StandardBlockErrorState } from "block-system/components/BlockErrors/StandardBlockErrorState";

export function ChatbotDisabled(
  props: Pick<React.ComponentProps<typeof StandardBlockErrorState>, "className">
) {
  return (
    <StandardBlockErrorState
      {...props}
      title="Chatbot unavailable"
      description="Access is disabled."
    />
  );
}

export function ChatbotDisabledEmbedded() {
  return (
    <ChatbotDisabled className="-my-0.5 min-h-svh grow justify-center overflow-hidden rounded-none" />
  );
}

export function ChatbotDisabledEmbeddedPopup() {
  return <ChatbotDisabled className="grow justify-center" />;
}
